import Setting from '../../views/Settings/Setting.view';

export default Setting;
